import React, { useEffect, useState } from "react";
import "../../style/main.scss";
import Dropdown from "react-bootstrap/Dropdown";
import { Icon } from "@iconify/react";
import {
  Button,
  DropdownButton,
  Modal,
  ModalHeader,
  ModalTitle,
} from "react-bootstrap";
import ScriptModals from "../../page/ScriptModals/scriptModals";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { HashLoader } from "react-spinners";
import CopyToClipboard from "react-copy-to-clipboard";
import { SpinnerCircular } from "spinners-react";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import { isValidPhoneNumber } from "react-phone-number-input";
import { handleHangupCalls } from "../../helperFunctions";
import { BiPhoneIncoming } from "react-icons/bi";

const ScriptWriting = ({ modals, setModals }) => {
  //Loading
  const [isLoading, setIsLoading] = useState(false);
  const [scriptResponse, setScriptResponse] = useState("");
  const [convertedScriptResponse, setConvertedScriptResponse] = useState("");
  const [generateModal, setGenerateModal] = useState(false);
  const [gptCloneModal, setGptCloneModal] = useState(false);
  const [talkModal, setTalkModal] = useState(false);

  const [loading, setLoading] = useState(false);
  const [showRecording, setRecordingShow] = useState(false);
  const [isCopied, setIsCopied] = useState(false);
  const [aiGenerated, setAiGenerated] = useState();
  const [knowledgeAgents, setKnowledgeAgents] = useState([]);
  const [selected, setSelected] = useState("Connect A Knowledge Base");
  const [selectedKnowledgeBase, setSelectedKnowledgeBase] = useState([]);
  const [thumbnailUrl, setThumbnailUrl] = useState("");
  const [initialMessage, setInitialMessage] = useState("");

  //Receiver Name and phone
  const [receiverName, setReceiverName] = useState("");
  const [receiverPhone, setReceiverPhone] = useState("");

  const [voiceSelect, setVoiceSelection] = useState("1");

  const navigate = useNavigate();
  const location = useLocation();

  var authToken = localStorage.getItem("bearerToken");
  var authEmail = localStorage.getItem("email");

  const handleTalkClose = () => {
    setReceiverName("");
    setTalkModal(false);
    setReceiverPhone("");
  };

  function convertToScriptString(responseScript) {
    if (!Array.isArray(responseScript)) return "";
    return responseScript.map((item) => `${item}\n`).join("");
  }

  useEffect(() => {
    setScriptResponse(location.state.scriptResponse);
  }, [location?.state?.scriptResponse]);

  useEffect(() => {
    if (!authToken) {
      if (location.pathname != "/register") {
        navigate("/login");
      }
      navigate("/login");
    }
  }, []);

  useEffect(() => {
    setConvertedScriptResponse(scriptResponse);
  }, [scriptResponse]);

  const handleRecordingClose = () => setRecordingShow(false);
  const handleRecordingShow = () => {
    setGenerateModal(false);
    setRecordingShow(true);
  };

  const handleGPTCloneModal = () => {
    setGptCloneModal(!gptCloneModal);
    setLoading(false);
    setIsCopied(false);
  };

  const handleScriptModal = () => {
    setGenerateModal(!generateModal);
    setLoading(false);
  };

  const handleClose = () => {
    setModals({
      modelAction: false,
      modalMagic: false,
      modalInstruction: false,
      modalPost: false,
      modalStats: false,
    });
  };
  function checkValidationForAgentTalk() {
    var error = false;
    if (!receiverName || receiverName == "" || receiverName == undefined) {
      error = true;
      toast.warning("Please enter a valid name", { toastId: "errorName" });
    }
    if (
      !receiverPhone ||
      receiverPhone == "" ||
      receiverPhone == undefined ||
      !isValidPhoneNumber(receiverPhone)
    ) {
      toast.warning("Please enter a valid phone number", {
        toastId: "errorPhone",
      });
      error = true;
    }
    // if (initialMessage === "") {
    //   toast.warning("Please Enter initial message", {
    //     toastId: "errorInputs",
    //   });
    //   error = true;
    // }
    if (convertedScriptResponse === "") {
      toast.warning("Please Enter script !!", {
        toastId: "errorInputs",
      });
      error = true;
    }
    return error;
  }
  function checkValidation() {
    var error = false;
    // if (initialMessage === "" && convertedScriptResponse === "") {
    //   toast.warning("Please Enter initial message and Script", {
    //     toastId: "errorInputs",
    //   });
    //   error = true;
    // }
    // if (initialMessage === "") {
    //   toast.warning("Please Enter initial message", {
    //     toastId: "errorInputs",
    //   });
    //   error = true;
    // }
    if (convertedScriptResponse === "") {
      toast.warning("Please Enter script !!", {
        toastId: "errorInputs",
      });
      error = true;
    }
    return error;
  }
  const handleTalkShow = () => {
    if (!checkValidation()) {
      setTalkModal(true);
    }
  };
  const handleAgentCall = async () => {
    try {
      if (checkValidationForAgentTalk()) {
      } else {
        setIsLoading(true);

        let data = JSON.stringify({
          to_phone: [receiverPhone],
          //  String
          name: receiverName,
          //String
          script: initialMessage + convertedScriptResponse,
          //Array
          knowledgeBase: selectedKnowledgeBase,
          calendarAvailabilities: "all classes scehduled",
          voice_id: voiceSelect,
        });
        let config = {
          method: "post",
          maxBodyLength: Infinity,
          url: `${process.env.REACT_APP_PYTHON_API}/outboundcall`,
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
          },
          data: data,
        };
        axios
          .request(config)
          .then((response) => {
            console.log(JSON.stringify(response.data));
            setIsLoading(false);
            // handleTalkClose();
            toast.success("Call initiated !!", { toastId: "promptSaved" });
          })
          .catch((error) => {
            console.log(error);
            setIsLoading(false);
            if (error?.response?.data?.detail) {
              toast.error(error?.response?.data?.detail, {
                toastId: "callingError",
              });
            } else {
              toast.error("Error while calling. Please check console logs", {
                toastId: "callingError",
              });
            }
          });
      }
    } catch (err) {
      console.log(err);
      setIsLoading(false);
      toast.error("Error while calling", { toastId: "callingError" });
    }
  };
  useEffect(() => {
    if (selected && selected?._id) {
      getAllQuestionsofSelectedKB();
    }
  }, [selected]);
  const UploadFileToS3 = async (file, fileFolderPath) => {
    // console.log(fileFolderPath);
    const convertedFile = await convertToBase64(file);
    // console.log(fileFolderPath);
    return new Promise(async (resolve, reject) => {
      try {
        //Url set in the server. Server will return s3 object download url
        let url = `${process.env.REACT_APP_API_URL}/aws-Fileupload`;
        // let url = `${process.env.REACT_APP_API_URL}/aws-upload`;
        setLoading(true);
        axios
          .post(
            url,
            {
              file: convertedFile,
              fileFolderPath: fileFolderPath,
              fileName: file.name,
              fileType: file.type,
            },
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${authToken}`,
              },
            }
          )
          .then((response) => {
            console.log("response after upload", response);
            if (response.data.success == true) {
              console.log("response.data.file_url", response.data.file_url);

              setThumbnailUrl(response.data.file_url);

              // if (response.data.thumbnail_url) {
              //   const myUrl = response.data.thumbnail_url;
              //   // console.log("Hammad's url", myUrl);
              //   // handleGetGptResponse(myUrl);
              // }
              resolve({
                success: true,
                thumbnail_url: response.data.file_url,
              });
            } else {
              setLoading(false);
              reject({ success: false, error: response.data.error });
            }
          })
          .catch((err) => {
            console.log(err);
            setLoading(false);
            reject({ success: false, error: err });
            toast.error(`Error! Please try again`, { toastId: "awsError" });
          });
      } catch (error) {
        console.log(error);
        setLoading(false);
        reject({ success: false, error });
        toast.error(`Error! Please try again`, { toastId: "awsError" });
      }
    });
  };
  const convertToBase64 = (file) => {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        resolve(reader.result);
      };
    });
  };

  const handleFileChange = (event) => {
    const File = event.target.files[0];
    // console.log(File);
    const fileFolderPath = "audio";

    if (File) {
      UploadFileToS3(File, fileFolderPath)
        .then((result) => {
          // setLoading(true);
          console.log("Upload successful:", result);
          handleGetGptResponse(result.thumbnail_url);
        })
        .catch((error) => {
          console.error("Upload failed:", error);
        });
    } else {
      console.error("No file selected.");
    }
  };

  const handleGetGptResponse = async (url) => {
    // console.log("authToken", authToken);
    try {
      setRecordingShow(true);
      setLoading(true);
      console.log("inside functtion===========================", url);
      console.log("inside location===========================", location);
      let data = {
        file: url,
      };
      let config = {
        method: "post",
        maxBodyLength: Infinity,
        url: `${process.env.REACT_APP_API_URL}/transcribe/${location.state.agentId}`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
        data: data,
      };
      console.log("inside functtion", url);
      axios
        .request(config)
        .then((response) => {
          console.log("inside functtion", url);
          console.log(JSON.stringify(response.data));
          //display back prompt
          if (response.data) {
            const GeneratedResponse = response.data;
            console.log(`GeneratedResponse`, GeneratedResponse);
            setAiGenerated(GeneratedResponse);
            setRecordingShow(false); // gpt response modal
            setGptCloneModal(true); // gpt response modal
            setLoading(false);
          }
        })
        .catch((error) => {
          setLoading(false);
          console.log(error);
        });
    } catch (err) {
      console.log(err);
      setLoading(false);
      toast.error("Something went wrong!", { toastId: "gptResponseError" });
    }
  };

  const handleCopyButtonClick = () => {
    setIsCopied(true);
  };
  const handleModalCloseToResetCopyState = () => {
    setIsCopied(false);
  };
  const getAllQuestionsofSelectedKB = async () => {
    try {
      setIsLoading(true);
      console.log("Fetching Qs");
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/questions/${selected._id}`,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();
      console.log(data);
      setSelectedKnowledgeBase(data.responce);
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching agent:", error);
      setIsLoading(false);
    }
  };
  const getAllAgent = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/knowledge-agent`,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();
      console.log(data);
      setKnowledgeAgents(data.knowledgeAgents);
      console.log(data);
    } catch (error) {
      console.error("Error fetching agent:", error);
    }
  };

  useEffect(() => {
    getAllAgent();
  }, []);

  function FormatString(value) {
    const unformattedString = value;

    // Split the unformatted string into paragraphs based on periods (.)
    const paragraphs = unformattedString.split(". ");

    // Remove empty paragraphs
    const filteredParagraphs = paragraphs.filter(
      (paragraph) => paragraph.trim() !== ""
    );

    // Join each paragraph with a period and a newline character
    const formattedText = filteredParagraphs.map(
      (paragraph, index) => paragraph.trim() + "."
    );
    console.log(paragraphs);
    return formattedText;
  }
  // Function to strip HTML tags from a string

  function saveScript() {
    try {
      if (checkValidation()) {
      } else {
        setIsLoading(true);

        let config = {
          method: "PATCH",
          url: `${process.env.REACT_APP_API_URL}/agentPrompt/${location?.state?.agentId}`,
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
          data: {
            prompt: convertedScriptResponse,
          },
        };
        axios
          .request(config)
          .then((response) => {
            console.log(JSON.stringify(response.data));
            setIsLoading(false);
            toast.success("Prompt Saved !!", { toastId: "promptSaved" });
          })
          .catch((error) => {
            console.log(error);
            setIsLoading(false);
            if (error?.response?.data?.detail) {
              toast.error(error?.response?.data?.detail, {
                toastId: "promptSaveError",
              });
            } else {
              toast.error("Error while saving. Please check console logs", {
                toastId: "promptSaveError",
              });
            }
          });
      }
    } catch (err) {
      console.log(err);
      setIsLoading(false);
      toast.error("Error while saving", { toastId: "promptSaveError" });
    }
  }

  return (
    <div>
      {isLoading && (
        <>
          <div className="loader">
            <SpinnerCircular
              color="#ffffff"
              size={"20%"}
              thickness={150}
              secondaryColor="#32C0BE"
            />
            <span className="customLoadingText">Loading...</span>
          </div>
        </>
      )}
      {/* <pre>{JSON.stringify(location, null, 2)}</pre> */}
      <div className="script">
        <div className="script-content">
          <div className="right">
            <div className="inner-content w-100">
              <div className="content">
                <Icon icon="arcticons:nrf-connect" width="24" height="24" />
                <Dropdown>
                  <Dropdown.Toggle variant="success" id="dropdown-basic">
                    {selected != "Connect A Knowledge Base"
                      ? `Connected to ${selected.name}`
                      : selected}
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    {knowledgeAgents.length > 0 ? (
                      knowledgeAgents.map((agent) => (
                        <Dropdown.Item onClick={() => setSelected(agent)}>
                          {agent.name}
                        </Dropdown.Item>
                      ))
                    ) : (
                      <Dropdown.Item>No Knowledgebase Found</Dropdown.Item>
                    )}
                    {/* <Dropdown.Item href="#/action-1">
                    Muhammad Shehryar
                  </Dropdown.Item>
                  <Dropdown.Item href="#/action-2" className="text-primary">
                    + Add A New Knowledge Base
                  </Dropdown.Item> */}
                  </Dropdown.Menu>
                </Dropdown>
              </div>
              <div className="content">
                <Icon
                  icon="solar:user-speak-rounded-broken"
                  width="24"
                  height="24"
                />
                <div className="special">
                  <label htmlFor="1">
                    <div className="male">
                      Male 1
                      <input
                        type="radio"
                        name="voice-select"
                        id="1"
                        value="1"
                        defaultChecked
                        onChange={(e) => {
                          setVoiceSelection(e.target.value);
                        }}
                      />
                    </div>
                  </label>
                  <label htmlFor="2">
                    <div className="female">
                      Female 1
                      <input
                        type="radio"
                        name="voice-select"
                        id="2"
                        value="2"
                        onChange={(e) => {
                          setVoiceSelection(e.target.value);
                        }}
                      />
                    </div>
                  </label>
                </div>
              </div>
              <div className="content">
                <Icon
                  icon="solar:user-speak-rounded-broken"
                  width="24"
                  height="24"
                />
                <div className="special">
                  <label htmlFor="3">
                    <div className="male">
                      Male 2
                      <input
                        type="radio"
                        name="voice-select"
                        id="1"
                        value="3"
                        defaultChecked
                        onChange={(e) => {
                          setVoiceSelection(e.target.value);
                        }}
                      />
                    </div>
                  </label>
                  <label htmlFor="4">
                    <div className="female">
                      Female 2
                      <input
                        type="radio"
                        name="voice-select"
                        id="2"
                        value="4"
                        onChange={(e) => {
                          setVoiceSelection(e.target.value);
                        }}
                      />
                    </div>
                  </label>
                </div>
              </div>
              {/* <div className="content">
                <BiPhoneIncoming size={23} />
                <div className="special">
                  Phone:{" "}
                  {process.env.REACT_APP_INBOUND_PHONE_NO ? (
                    process.env.REACT_APP_INBOUND_PHONE_NO
                  ) : (
                    <p style={{ color: "red", fontSize: 12 }}>
                      Add phone number from env
                    </p>
                  )}
                </div>
              </div> */}
              {/* <div className="content">
                <Icon
                  icon="solar:user-speak-rounded-broken"
                  width="24"
                  height="24"
                />
                <div className="special">
                  <label htmlFor="3">
                    <div className="female">
                      Male 2
                      <input
                        type="radio"
                        name="voice-select"
                        id="3"
                        value="3"
                        onChange={(e) => {
                          setVoiceSelection(e.target.value);
                        }}
                      />
                    </div>
                  </label>
                  <label htmlFor="4">
                    <div className="female">
                      Female 2
                      <input
                        type="radio"
                        name="voice-select"
                        id="4"
                        value="4"
                        onChange={(e) => {
                          setVoiceSelection(e.target.value);
                        }}
                      />
                    </div>
                  </label>
                </div>
              </div> */}

              {/* <div
              className="content"
              onClick={() =>
                setModals((prev) => ({
                  ...prev,
                  modalPost: !prev.modalPost,
                }))
              }
            >
              <Icon
                icon="material-symbols-light:post-add-sharp"
                width="24"
                height="24"
              />
              <p className="right-para">Post Call Notes</p>
            </div>
            <div
              className="content"
              onClick={() =>
                setModals((prev) => ({
                  ...prev,
                  modalStats: !prev.modalStats,
                }))
              }
            >
              <Icon icon="iconoir:stats-up-square" width="24" height="24" />
              <p className="right-para">Setup Stats Tracking</p>
            </div> */}
              {/* <div className="content">
              <Icon icon="arcticons:nrf-connect" width="24" height="24" />
              <Dropdown>
                <Dropdown.Toggle variant="success" id="dropdown-basic">
                  Connect A Knowledge Base
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.Item href="#/action-1">
                    Muhammad Shehryar
                  </Dropdown.Item>
                  <Dropdown.Item href="#/action-2" className="text-primary">
                    + Add A New Knowledge Base
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div> */}
            </div>
            <div className="inner-btn">
              <button onClick={handleTalkShow} className="w-100 gap-3">
                <Icon
                  icon="ic:round-phone"
                  width="20"
                  height="20"
                  className="me-2"
                />
                Talk To Your Agent
              </button>
              <button onClick={saveScript} className="w-100 gap-3">
                Save Script
              </button>
              {/* <button onClick={handleHangupCalls} className="w-100 gap-3">
                <Icon
                  icon="ic:round-phone"
                  width="20"
                  height="20"
                  className="me-2"
                />
                Hangup All Calls
              </button> */}
            </div>
          </div>
          <div className="left">
            <h2 className="text-orange-gradient">
              {location?.state?.agentName}
              {/* {authEmail ? authEmail : "User"} */}
            </h2>

            {/* <p className="text-orange-gradient">Standard Editor</p> */}
            <div className="scroll-text">
              {/* <input
                type="text"
                placeholder="Enter initial message, eg: Hey Alex !"
                onChange={(e) => {
                  setInitialMessage(e.target.value);
                }}
                value={initialMessage}
                className="hey"
              /> */}

              <div className="responsegpt">
                {scriptResponse && (
                  <>
                    {/* <p style={{ color: "#d7d7d7" }}>
                      Wait for the Prospect to Respond
                    </p> */}
                    <textarea
                      wrap="hard"
                      rows={28}
                      placeholder="Enter script here..."
                      className="gptcontent"
                      style={{ resize: "none" }}
                      onChange={(e) =>
                        setConvertedScriptResponse(e.target.value)
                      }
                      value={convertedScriptResponse}
                    />
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Magic Modal  */}
      <Modal
        show={generateModal}
        onHide={handleScriptModal}
        centered
        size="lg"
        className="magic-modal"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body className="modal-body-4">
          <h4> How do you want to magically generate a script?s</h4>
          <div className="create-AI">
            <div className="bottom mt-3">
              <div className="checks mt-2">
                <div className="check-boxes" onClick={handleRecordingShow}>
                  <label>
                    <div className="generate">
                      <h6>Upload a call recording</h6>
                    </div>
                    <p className="p2 tex">
                      Clone your best rep by uploading a call recording. voxr
                      will take their call recording, transcribe it, and create
                      a framework from it that your agent can follow.
                    </p>
                  </label>
                </div>
                <div className="check-boxes">
                  <label>
                    <div className="generate">
                      <h6>Give voxr your exsisting script</h6>
                    </div>
                    <p className="p2 tex">
                      Copy and paste your current script and let voxr reformat
                      it an a way that is easy for your agent to follow.
                    </p>
                  </label>
                </div>
                <div className="check-boxes">
                  <label>
                    <div className="generate">
                      <h6>Use a proven template from voxr</h6>
                    </div>
                    <p className="p2 tex">
                      Select a proven template, give voxr some basic context,
                      and have AI customize it for your business.
                    </p>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <ScriptModals modals={modals} handleClose={handleClose}></ScriptModals>

      {/* Talk button Modal */}
      {/* <div style={{ position: "absolute", width: "100%" }}> */}

      <Modal
        show={talkModal}
        onHide={handleTalkClose}
        centered
        backdrop="static"
      >
        <ModalHeader closeButton>
          <ModalTitle> </ModalTitle>
        </ModalHeader>
        <Modal.Body className="talk-to-agent-modal-body">
          <h4>Talk To Your Agent</h4>
          <p>
            Once you press "Call" below, you'll join the queue to receive a call
            from your agent. When you reach first in line, voxr will call you at
            the number you enter below.
          </p>
          <div className="content">
            <div className="how">
              <h6>What name should we call you?</h6>
              <input
                disabled={isLoading}
                type="text"
                name=""
                id=""
                placeholder="Enter your name"
                value={receiverName}
                onChange={(e) => {
                  setReceiverName(e.target.value);
                }}
              />
            </div>
            <div className="how mt-3">
              <h6>What phone number do you want us to call?</h6>
              <PhoneInput
                disabled={isLoading}
                placeholder="Enter phone number"
                value={receiverPhone}
                onChange={(phone) => {
                  setReceiverPhone(phone);
                }}
              />
              {/* <input type="number" name="" id="" placeholder="5550123456"
                value={receiverPhone} onChange={e => { setReceiverPhone(e.target.value) }}
              /> */}
            </div>
          </div>
          <Button
            disabled={isLoading}
            // variant="primary"
            onClick={handleAgentCall}
            // onClick={handleTalkClose}
            className="call-btn mt-5 px-5"
          >
            <Icon icon="ic:round-phone" width="24" height="24" />
            Call
          </Button>
          {/* <Button
            // variant="primary"
            onClick={handleHangupCalls}
            // onClick={handleTalkClose}
            className="call-btn mt-5 px-5"
          >
            <Icon icon="ic:round-phone" width="24" height="24" />
            Hangup All Calls
          </Button> */}
        </Modal.Body>
      </Modal>
      {/* </div> */}
      {/* {loading && (
        <div className="loader">
          <HashLoader color="#0C72F7" />
        </div>
      )} */}
      {/* Modal for call recording */}
      <Modal
        show={showRecording}
        onHide={handleRecordingClose}
        centered
        size="lg"
        className="recording-modal"
        backdrop="static"
        keyboard={false}
      >
        {loading ? (
          <div
            className="loader"
            style={{
              // position: "absolute", width: "100%", zIndex: "2"
              display: "contents",
            }}
          >
            <Modal.Header closeButton>
              <Modal.Title> </Modal.Title>
            </Modal.Header>
            <HashLoader color="#0C72F7" />
            <h3 id="h3loader">AI is analyzing content...</h3>
          </div>
        ) : (
          <>
            <Modal.Header closeButton>
              <Modal.Title> </Modal.Title>
            </Modal.Header>
            <Modal.Body className="recording-body">
              <h4>Upload A Call Recording</h4>
              <p>
                Clone your best rep by uploading a call recording from them and
                we'll magically create a script for your voxr Agent to follow
                based on it.
              </p>
              <div className="upload-audio" id="audioFile">
                <form
                  action="/upload"
                  method="post"
                  enctype="multipart/form-data"
                  id="audioFile"
                >
                  <label for="audioFile" id="audioFile">
                    <Icon icon="tabler:upload" width="35" height="35" />
                    Click to upload audio from computer
                  </label>
                  <input
                    type="file"
                    id="audioFile"
                    name="audioFile"
                    accept="audio/*"
                    onChange={handleFileChange}
                  />
                  <br />
                </form>
              </div>
            </Modal.Body>
          </>
        )}
      </Modal>

      {/* Clone Gpt Response */}

      <Modal
        show={gptCloneModal}
        onHide={handleGPTCloneModal}
        centered
        size="lg"
        className="clone-modal"
        backdrop="static"
      >
        {/* {loading ? (
          <div
            className="loader"
            style={{
              // position: "absolute", width: "100%", zIndex: "2"
              display: "contents",
            }}
          >
            <HashLoader color="#0C72F7" />
            <h3 id="h3loader">AI is analyzing content...</h3>
          </div>
        ) : ( */}

        <Modal.Header closeButton>
          <Modal.Title> </Modal.Title>
        </Modal.Header>
        <Modal.Body className="clone-body">
          <h4>Cloning Successful! Copy Your Script Below</h4>

          <div className="gptresponse mt-4">
            <textarea>{aiGenerated?.gptResponse}</textarea>
          </div>
          <div className="btnclone mt-3">
            <Button
              className=""
              style={{ marginBottom: "0" }}
              onClick={() => {
                handleGPTCloneModal();
                handleGetGptResponse(thumbnailUrl);
              }}
            >
              Regenerate
            </Button>
            <CopyToClipboard
              text={aiGenerated?.gptResponse}
              onCopy={(e) => {
                navigator.clipboard.writeText(aiGenerated?.gptResponse);
                handleCopyButtonClick();
              }}
            >
              <Button
                variant={isCopied ? "copied" : "primary"}
                className={` ${isCopied ? "copied" : ""}`}
              >
                {isCopied
                  ? "Prompt And Script Copied!!"
                  : "Copy Prompt And Script"}
              </Button>
            </CopyToClipboard>
          </div>
        </Modal.Body>

        {/* )} */}
      </Modal>
    </div>
  );
};

export default ScriptWriting;
